import PropTypes from 'prop-types'

const Wrap = ({ on, wrapper: Wrapper, children }) =>
  on ? <Wrapper>{children}</Wrapper> : children

export default Wrap

Wrap.propTypes = {
  children: PropTypes.node,
  wrapper: PropTypes.func,
  on: PropTypes.bool,
}
